import { crmSnippetTemplates } from '../services/crmSnippetTemplates';

export function phoneForWhatsApp(tel) {
  if (!tel || tel === '–') return '';
  let d = String(tel).replace(/\D/g, '');
  if (!d) return '';
  if (d.startsWith('0')) d = `49${d.slice(1)}`;
  else if (!d.startsWith('49') && d.length >= 10) d = `49${d}`;
  return d;
}

export function fillWhatsAppTemplate(text, lead) {
  const first = (lead?.name || '').trim().split(/\s+/)[0] || '';
  return (text || '')
    .replace(/\{\{vorname\}\}/gi, first)
    .replace(/\{\{name\}\}/gi, lead?.name || '')
    .replace(/\{\{firma\}\}/gi, lead?.company || '');
}

export function defaultWhatsAppMessage(lead) {
  const tpl = crmSnippetTemplates.get();
  const fromList = tpl?.whatsappByBranch || tpl?.whatsappDefault;
  if (Array.isArray(fromList) && lead?.branch) {
    const hit = fromList.find(x => (x.branch || '').toLowerCase() === (lead.branch || '').toLowerCase());
    if (hit?.text) return fillWhatsAppTemplate(hit.text, lead);
  }
  const generic = tpl?.whatsappDefault?.text
    || 'Hallo {{vorname}}, kurze Rückfrage zu {{firma}} – haben Sie gerade 2 Minuten?';
  return fillWhatsAppTemplate(generic, lead);
}

export function buildWhatsAppUrl(lead, message) {
  const phone = phoneForWhatsApp(lead?.tel || lead?.handy);
  if (!phone) return null;
  const text = message ?? defaultWhatsAppMessage(lead);
  const q = text ? `?text=${encodeURIComponent(text)}` : '';
  return `https://wa.me/${phone}${q}`;
}
